import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';

/**
 * MaintenanceGate — wraps the entire authenticated app.
 * Polls /api/settings/public every 30s. When maintenance_mode is ON and the
 * viewer is NOT admin, renders a full-page “We'll be right back” screen.
 * Admin users continue to see the app normally (so they can flip it off).
 */
export default function MaintenanceGate({ children }) {
  const { user } = useAuth();
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get('/settings/public');
        if (!cancelled) setMaintenance(!!data.maintenance_mode);
      } catch { /* ignore */ }
    };
    poll();
    timer = setInterval(poll, 30000);
    return () => { cancelled = true; clearInterval(timer); };
  }, []);

  const isAdmin = user && user.role === 'admin';
  if (maintenance && !isAdmin) {
    return (
      <div className="maint-screen" data-testid="maintenance-screen">
        <div className="maint-card">
          <div className="maint-emoji">🛠️</div>
          <h1 className="maint-title">We'll be right back</h1>
          <p className="maint-body">
            Clanster is undergoing a quick tune-up. Hang tight — this usually only takes a few minutes.
          </p>
          <button
            type="button"
            className="maint-refresh"
            onClick={() => window.location.reload()}
            data-testid="maintenance-refresh"
          >
            Refresh
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {maintenance && isAdmin && (
        <div className="maint-admin-banner" data-testid="maint-admin-banner">
          🛠️ Maintenance mode is ON — regular users see the maintenance screen. You (admin) can still browse the app.
        </div>
      )}
      {children}
    </>
  );
}
